import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReportsMapperService } from './reports.mapper.service';
import { ReportsService } from './reports.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    ReportsService,
    ReportsMapperService
  ]
})
export class ReportsModule { }
